/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {
  getUGCCustomizedComponents(store) {
    const { components = {} } = store.tempData.features[store.tempData.activeUGCIndex].recipe;
    const recipeComponents = Object.keys(components);
    return recipeComponents.length
      ? recipeComponents.filter(e => components[e].hasOwnProperty("ugc"))
      : [];
  },
  getUGCEnabledComponents(store, getters, rootState) {
    if (!rootState.utils.configuration || !rootState.utils.pdm) return [];
    const { configuration } = rootState.utils;
    const { pdm } = rootState.utils;
    const ugcConfig = configuration.ugc.models_enabled[pdm.sku]
    return ugcConfig?.components ?? [];
  },
  getApparelUGCEnabledComponents(store, getters, rootState) {
    if (!rootState.utils.configuration || !rootState.utils.pdm) return [];
    const { recipe_v2 } = rootState.recipe;
    const componentNames = Object.keys(recipe_v2.components ?? {})
    if (componentNames.length === 0) return [];
    const ugcComponents = getters.getUGCEnabledComponents;
    const filterComponent = ugcComponents.filter(componentName => {
      return recipe_v2.components[componentName];
    });

    return ugcComponents && filterComponent ? filterComponent : []
  },

  getComponentsWithUGCApplied(store, getters, rootState) {
    const { recipe_v2 } = rootState.recipe;
    if (!recipe_v2) return [];
    const ugcIndentifier = 'ugc';
    const patternSubgroupIdentifierArray = ["checkerboard-creator", "custom-checkerboard"];
    const componentKeys = Object.keys(recipe_v2.components || {});
    return componentKeys.filter(component =>
      recipe_v2.components[component].hasOwnProperty(ugcIndentifier) && recipe_v2.components[component].group === ugcIndentifier && !patternSubgroupIdentifierArray.includes(recipe_v2.components[component].subgroup)
    );
  },
  getComponentsByUGCSubgroupApplied(store, getters, rootState) {
    return ({ subgroupIdentifier }) => {
      const { recipe_v2 } = rootState.recipe;
      if (!recipe_v2) return [];
      const ugcIndentifier = 'ugc';
      const componentKeys = Object.keys(recipe_v2.components || {});
      return componentKeys.filter(component =>
        recipe_v2.components[component].hasOwnProperty(ugcIndentifier) && recipe_v2.components[component].group === ugcIndentifier && recipe_v2.components[component].subgroup === subgroupIdentifier
      );
    };
  },
  getNextUGCComponent(store, getters, rootState) {
    const ugcComponents = getters.getUGCEnabledComponents;
    const { activeComponent } = rootState.standardNavigation;
    const secondaryComponent = getters.getUGCComponentNotActive;
    const filterComponent = ugcComponents.filter(componentName => {
      return componentName === secondaryComponent || componentName !== activeComponent;
    });
    return filterComponent[0];
  },
  getUGCComponentNotActive(store, getters, rootState) {
    const ugcComponents = getters.getUGCEnabledComponents;
    let ugcActiveComponent = store.tempData.features[store.tempData.activeUGCIndex].activeUGCComponent;
    // This validation is valid in precreatedRecipe specially in
    // authentic classic model since the tempData.activeUGCComponent is not the same
    // with the component selected in the fly menu
    if (rootState.standardNavigation.activeComponent !== store.tempData.features[store.tempData.activeUGCIndex].activeUGCComponent) {
      ugcActiveComponent = rootState.standardNavigation.activeComponent;
    }
    const newComponent = ugcComponents.filter(item => {
      return item !== ugcActiveComponent;
    });
    return newComponent[0];
  },
  getEditsApplied(state) {
    const edits = !state.stateManager.steps ? [] :
      state.stateManager.steps
        .map(element => element.control)
        .filter(element => element);
    return edits.length ? edits.join(',') : '';
  },
  getLibraryEnabledComponents(store, getters, rootState) {
    if (!rootState.utils.configuration || !rootState.utils.pdm) return [];
    const { configuration } = rootState.utils;
    const { pdm } = rootState.utils;
    const libraryConfig = configuration.image_library?.models_enabled?.[pdm.sku]
    return libraryConfig?.components ?? [];
  },
};

export default getters;
